module.exports = __webpack_public_path__ + "static/img/footer_img1.0e8124b6.png";